import { DataService } from '../../../services/data_service';
import { formStyle } from '../../../core/forms/WFormFramework';
import { i18n } from '../../../i18n/i18n';
import { IDs } from '../../../helpers/IDs';
import { Import } from './../routinen/Import';
import { Lastgang } from './../routinen/Lastgang';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import style from './LastgangKonfiguration.less';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

export interface LastgangKonfigurationProps {
    archivTid?: number;
    config?: any;
    data: string;
    dataGlobal: any;
    onChange: (config: any) => void;
    onClose: () => void;
    onDataLoaded?: (data: string) => void;
    title?: string | JSX.Element;
}

export interface LastgangKonfigurationState {
    columns: string[];
    config: any;
    isValidConfig: boolean;
    values: any[];
}

export class LastgangKonfiguration extends React.Component<LastgangKonfigurationProps, LastgangKonfigurationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            columns: [],
            config: null,
            isValidConfig: null,
            values: []
        };
    }

    private FileTool: any;
    private sheets: string[] = [];
    private tsStart: number = null;
    private types: any = {
        datetime: { name: 'Datum/Zeit' },
        date: { name: 'Datum' },
        time: { name: 'Zeit' },
        value: { name: 'Wert' }
    };
    private readonly units: any = {
        w: { name: 'W' },
        kw: { name: 'kW' },
        mw: { name: 'mW' },
        wh: { name: 'Wh' },
        kwh: { name: 'kWh' },
        mwh: { name: 'mWh' },
        kvar: { name: 'kVAr' }
    };

    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        this.init();
    }

    getFileData(tid: number): void {
        this.dataService.loadDataForModul(
            IDs.ENT_ARCHIV_ITEMS,
            { tid },
            { resolve: true, fieldList: 'name, file' },
            'wips',
            (result: any) => {
                if ((result[IDs.ENT_ARCHIV_ITEMS] || []).length) {
                    let fileName: string = result[IDs.ENT_ARCHIV_ITEMS][0].file || '';

                    if (fileName.substr(0, 11) === 'wips3_2013/') {
                        fileName = fileName.substr(11);
                    }
                    this.dataService.loadRessource(fileName, 'archiv', (b64: string) =>
                        typeof this.props.onDataLoaded === 'function'
                            ? this.props.onDataLoaded(Base64.atob(b64))
                            : null
                    );
                } else {
                }
            }
        );
    }

    getTypesByIndex(index: number): any {
        const isSelected: any = {};
        const types: any = { ...this.types };

        Object.keys(types).forEach((key: string) => {
            isSelected[key] = !!(typeof types[key].column !== 'undefined');
        });

        Object.keys(types).forEach((key: string) => {
            if (!isSelected[key] || types[key].column === index) {
                return;
            }

            if (['date', 'time'].indexOf(key) !== -1) {
                delete types[key];
                delete types['datetime'];
            } else if (key === 'datetime') {
                delete types[key];
                delete types['date'];
                delete types['time'];
            }
        });

        return types;
    }

    getUnitsByIndex(index: number): any {
        const key: string = ((this.state.config.fields || {})[index] || {}).type || null;

        return key !== null && ['date', 'datetime', 'time'].indexOf(key) === -1
            ? this.units
            : {};
    }

    init(): void {
        if (this.props.data) {
            this.FileTool = new Import(this.props.data, { cellNF: true });
            this.sheets = this.FileTool.getSheets(true) || [];

            if (this.sheets.length) {
                let config: any = {};

                if (this.props.config) {
                    if (typeof this.props.config === 'string') {
                        try {
                            config = JSON.parse(this.props.config);
                        } catch (error) {
                            console.log(error.message);
                        }
                    } else if (typeof this.props.config === 'object') {
                        config = { ...this.props.config };
                    }
                }
                config = { fields: {}, indexSheetData: 1, indexSheetHeader: 0, sheet: this.sheets[0], ...config };
                const indexSheetData: number = typeof config.indexSheetData === 'number' ? config.indexSheetData : 1;
                const indexSheetHeader: number = typeof config.indexSheetHeader === 'number' ? config.indexSheetHeader : 0;
                const sheet: string = typeof config.sheet === 'string' ? config.sheet : this.sheets[0];
                const columns: any[] = this.FileTool.getSheetRowByName(sheet, indexSheetHeader) || [];
                const values: any[] = this.FileTool.getSheetRowByName(sheet, indexSheetData) || [];

                columns.forEach((name: string, index: number) => {
                    if (!this.props.config || typeof config.fields[index] === 'undefined') {
                        config.fields[index] = { name };
                    } else {
                        const key: string = config.fields[index].type;

                        if (typeof key === 'string' && key !== 'value' && typeof this.types[key] !== 'undefined') {
                            this.types[key].column = index;
                        }
                    }
                });
                this.setState({ columns, config, values });
            } else {
                this.setState({ config: {} });
            }
        } else if (this.props.archivTid) {
            this.getFileData(this.props.archivTid);
        }
    }

    isDate(index: number): boolean {
        const date: number = Lastgang.getDate((this.state.values || [])[index]);
        const moment: any = Moment.unix(date / 1000);
        const type: string = ((this.state.config.fields || {})[index] || {}).type || null;

        if (['date', 'datetime'].indexOf(type) === -1 || !date || !moment.isValid()) {
            return false;
        }

        return true;
    }

    isTime(index: number): boolean {
        const fields: any = this.state.config.fields || {};
        const indexDate: number = Object.keys(fields).findIndex((key: string) => fields[key].type === 'date');
        const values: any[] = this.state.values || [];
        const date: number = Lastgang.getDate(values[indexDate]);
        const time: number = Lastgang.getTime(values[index], values[indexDate]);
        const type: string = ((this.state.config.fields || {})[index] || {}).type || null;
        let time2: number = time;

        if (typeof values[index] === 'number' && typeof values[indexDate] === 'number') {
            const date2: number = Math.ceil((values[indexDate] - (25567 + 2)) * 86400);
            const moment: any = Moment.unix(date2).hour(0).minute(0).second(0).millisecond(0);
            const moment2: any = Moment.unix((+moment + time) / 1000);
            time2 = time - ((moment2.utcOffset() - moment.utcOffset()) * 60 * 1000);
        }
        const moment: any = Moment.unix((date + time2) / 1000);

        if (type !== 'time' || time2 === null || !moment.isValid()) {
            return false;
        }

        return true;
    }

    onChange(data: any): void {
        const fields: any = this.state.config.fields || {};
        const index: number = typeof data.index === 'number' ? data.index : null;
        const name: string = data.name || fields[index] || null;
        const value: any = data.value || null;
        fields[index] = { ...fields[index], [name]: value };

        if (name === 'type') {
            this.setTypeColumn(value, index);
            this.setUnitRow(value, index);
        }
        this.setState({ config: { ...this.state.config, fields } });
    }

    onIndexChange(data: any): void {
        const config: any = {};
        const name: string = (data || {}).name || null;
        const state: any = {};
        const stateConfig: any = { ...(this.state.config || {}) };
        const indexSheetData: number = typeof stateConfig.indexSheetData !== 'undefined' ? stateConfig.indexSheetData : null;
        const indexSheetHeader: number = typeof stateConfig.indexSheetHeader !== 'undefined' ? stateConfig.indexSheetHeader : null;
        const sheet: string = stateConfig.sheet || null;
        const value: number = +(data || {}).value > 0 ? +data.value - 1 : 0;

        switch (true) {
            case name === 'data' && value !== indexSheetData:
                config.indexSheetData = value;

                if (value < indexSheetHeader) {
                    config.indexSheetHeader = value ? value - 1 : 0;
                }
                break;
            case name === 'header' && value !== indexSheetHeader:
                config.indexSheetHeader = value;

                if (value >= indexSheetData) {
                    config.indexSheetData = value + 1;
                }
                break;
        }

        if (typeof config.indexSheetData !== 'undefined' && config.indexSheetData !== indexSheetData) {
            state.config = { ...stateConfig, ...config };
            state.values = this.FileTool.getSheetRowByName(sheet, config.indexSheetData) || [];
        }

        if (typeof config.indexSheetHeader !== 'undefined' && config.indexSheetHeader !== indexSheetHeader) {
            state.columns = this.FileTool.getSheetRowByName(sheet, config.indexSheetHeader) || [];

            state.columns.forEach((name: string, index: number) => {
                stateConfig.fields[index] = { ...stateConfig.fields[index], name };
            });
            state.config = { ...stateConfig, ...config };
        }

        if (Object.keys(state).length) {
            this.setState({ ...state });
        }
    }

    onSheetChange(name: string): void {
        const config: any = { fields: {}, indexSheetData: 1, indexSheetHeader: 0, sheet: name };
        const indexSheetData: number = typeof config.indexSheetData === 'number' ? config.indexSheetData : 1;
        const indexSheetHeader: number = typeof config.indexSheetHeader === 'number' ? config.indexSheetHeader : 0;
        const columns: any[] = this.FileTool.getSheetRowByName(name, indexSheetHeader) || [];
        const values: any[] = this.FileTool.getSheetRowByName(name, indexSheetData) || [];

        columns.forEach((name: string, index: number) => {
            config.fields[index] = { name };
        });

        Object.keys(this.types).forEach((key: string) => delete this.types[key].column);
        this.setState({ columns, config, values });
    }

    render(): JSX.Element {
        if (this.tsStart === null) {
            this.tsStart = +new Date();
        } else if (this.props.data && this.state.config && this.tsStart !== undefined ) {
            console.log('processing time: ', `${(+new Date() - this.tsStart) / 1000} sec`);
            this.tsStart = undefined;
        }

        if (!this.props.data || !this.state.config) {
            return (
                <div className={style.wrapper}>
                    <WSpinner />
                </div>
            );
        }

        return (
            <div className={style['lastgang-konfiguration']} ref={(ref: any) => this.setValidation(ref)}>
                {/* {this.renderTitle()} */}
                {this.renderMeta()}
                {this.renderHeader()}
                {this.renderRows()}
                {this.renderButtons()}
            </div>
        );
    }

    renderButtons(): JSX.Element {
        const disabled: boolean = !this.state.isValidConfig;
        const styleProps: React.CSSProperties = disabled && { backgroundColor: 'lightgray', cursor: 'not-allowed' };
        const tooltip: string = disabled ? 'Die Konfiguration ist unvollständig!' : null;

        return (
            <div className={style.buttons}>
                <WActionButton
                    label='Konfiguration übernehmen'
                    insideText='Konfiguration übernehmen'
                    key='save'
                    action='save'
                    disabled={disabled}
                    styleProps={styleProps}
                    tooltip={tooltip}
                    onAction={() => this.props.onChange(this.state.config)}
                />
                {/* <WActionButton
                    label='Schließen'
                    insideText='Schließen'
                    key='close'
                    action='delete'
                    onAction={this.props.onClose}
                /> */}
            </div>
        );
    }

    renderHeader(): JSX.Element {
        return (
            <div className={style.header}>
                <div>Spalte</div>
                <div>Bezeichnung</div>
                <div>Typ</div>
                <div>Einheit</div>
                <div>Wert</div>
            </div>
        );
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.dataGlobal}
                styleDivProps={{ paddingRight: 26, display: 'flex', flex: 1, alignSelf: 'center', justifyContent: 'flex-end' }}
                styleProps={{ margin: 0 }}
                label='Lastgang - Konfiguration'
                helpKey='dialog_lastgang_konfiguration'
                type='theme_info'
                style='theme_small'
                customElement='Info'
                editBar
                useTheme
            />
        );
    }

    renderIndexSheetData(): JSX.Element[] {
        return [
            <label key='label-data' htmlFor='index_sheet_data'>
                Zeile Datenbeginn:
            </label>,
            <input
                key='input-data'
                id='index_sheet_data'
                name='data'
                type='number'
                value={this.state.config.indexSheetData + 1}
                required
                onChange={(event: any) => this.onIndexChange(event.target)}
            />
        ];
    }

    renderIndexSheetHeader(): JSX.Element[] {
        return [
            <label key='label-header' htmlFor='index_sheet_header'>
                Zeile Bezeichnung:
            </label>,
            <input
                key='input-header'
                id='index_sheet_header'
                name='header'
                type='number'
                value={this.state.config.indexSheetHeader + 1}
                required
                onChange={(event: any) => this.onIndexChange(event.target)}
            />
        ];
    }

    renderMeta(): JSX.Element {
        return (
            <div className={style.meta}>
                {this.renderSheets()}
                {this.renderIndexSheetHeader()}
                {this.renderIndexSheetData()}
                {this.renderHelpIcon()}
            </div>
        );
    }

    renderNames(index: number): JSX.Element {
        return (
            <input
                name='name'
                type='text'
                value={((this.state.config.fields || {})[index] || {}).name}
                maxLength={100}
                onChange={(event: any) =>
                    this.onChange({ index, name: event.target.name, value: event.target.value })
                }
            />
        );
    }

    renderRow(index: number): JSX.Element[] {
        const name: string = typeof this.state.columns[index] !== 'undefined' ? this.state.columns[index] : null;
        const value: string = typeof this.state.values[index] !== 'undefined' ? this.state.values[index] : null;

        return [
            <div key='column-1' title={name}>
                {name}
            </div>,
            <div key='column-2'>
                {this.renderNames(index)}
                {this.renderValidation('name', index)}
            </div>,
            <div key='column-3'>
                {this.renderTypes(index)}
                {this.renderValidation('type', index)}
            </div>,
            <div key='column-4'>
                {this.renderUnits(index)}
            </div>,
            <div key='column-5' title={value}>
                {value}
            </div>
        ];
    }

    renderRows(): JSX.Element[] {
        return this.state.columns.map((name: string, index: number) =>
            <div key={`row-${index}`} className={style.fields}>
                {this.renderRow(index)}
            </div>
        );
    }

    renderSheets(): JSX.Element[] {
        return [
            <label key='label-sheet' htmlFor='sheet'>
                Blatt:
            </label>,
            <select
                key='select-sheet'
                id='sheet'
                name='sheet'
                value={this.state.config.sheet}
                disabled={!!(this.sheets.length === 1)}
                onChange={(event: any) => this.onSheetChange(event.target.value)}
            >
                {!this.sheets.length &&
                    <option>Nicht verfügbar</option>
                }
                {this.sheets.map((name: string, index: number) =>
                    <option
                        key={`sheet-${index}`}
                        value={name || null}
                    >
                        {name || null}
                    </option>
                )}
            </select>
        ];
    }

    renderTitle(): JSX.Element {
        return (
            <div className={style.title}>
                <div>Lastgang{`${this.props.title ? `: ${this.props.title}` : ''}`}</div>
                <div style={{ flex: 1, textAlign: 'right' }}>
                    <WHelpIcon
                        data={this.props.dataGlobal}
                        styleDivProps={{ display: 'inline-block' }}
                        styleProps={{
                            width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0
                        }}
                        label='Lastgang - Konfiguration'
                        helpKey='dialog_lastgang_konfiguration'
                        type='info'
                        editBar
                    />
                </div>
            </div>
        );
    }

    renderTypes(index: number): JSX.Element {
        const types: any = this.getTypesByIndex(index);

        return (
            <select
                name='type'
                value={((this.state.config.fields || {})[index] || {}).type || 0}
                disabled={!Object.keys(types).length}
                onChange={(event: any) =>
                    this.onChange({ index, name: event.target.name, value: event.target.value === '0' ? null : event.target.value })
                }
            >
                <option
                    key='type-'
                    value={0}
                >
                    {`<${i18n('keine Auswahl', 'sys')}>`}
                </option>
                {Object.keys(types).map((key: string) =>
                    <option
                        key={`type-${key}`}
                        value={key || undefined}
                    >
                        {this.types[key].name || null}
                    </option>
                )}
            </select>
        );
    }

    renderUnits(index: number): JSX.Element {
        const units: any = this.getUnitsByIndex(index);

        return (
            <select
                name='unit'
                value={((this.state.config.fields || {})[index] || {}).unit || 0}
                disabled={!Object.keys(units).length}
                onChange={(event: any) =>
                    this.onChange({ index, name: event.target.name, value: event.target.value === '0' ? null : event.target.value })
                }
            >
                <option
                    key='unit-'
                    value={0}
                >
                    {`<${i18n('keine Auswahl', 'sys')}>`}
                </option>
                {Object.keys(units).map((key: string) =>
                    <option
                        key={`unit-${key}`}
                        value={key || undefined}
                    >
                        {this.units[key].name || null}
                    </option>
                )}
            </select>
        );
    }

    renderValidation(key: string, index: number): JSX.Element {
        const validate: string = this.validateField(key, index);

        if (!validate) {
            return null;
        }

        return (
            <div
                className={formStyle.warnSign}
                style={{ margin: '-3px 1px 0 0', position: 'relative', float: 'right' }}
                title={validate}
            >
                *
            </div>
        );
    }
    
    setTypeColumn(key: string, index: number): void {
        if (key === null) {
            Object.keys(this.types).forEach((key2: string) => {
                if (this.types[key2].column === index) {
                    delete this.types[key2].column;
                }
            });
            delete this.state.config.fields[index].type;
        } else {
            Object.keys(this.types).forEach((key2: string) => {
                if (this.types[key2].column === index && key2 !== key) {
                    delete this.types[key2].column;
                }
            });

            if (key !== 'value') {
                this.types[key].column = index;
            }
        }
    }

    setUnitRow(key: string, index: number): void {
        if (key === null || ['date', 'datetime', 'time'].indexOf(key) !== -1) {
            delete this.state.config.fields[index].unit;
        }
    }

    setValidation(ref: any): void {
        if (ref === null) {
            return;
        }
        const isValidConfig: boolean = !ref.querySelectorAll('div[class^="warnSign"]').length
            && !!Object.keys(this.state.config || {}).length;

        if (isValidConfig !== this.state.isValidConfig) {
            this.setState({ isValidConfig });
        }
    }

    validateField(key: string, index: number): string {
        const fields: any = this.state.config.fields || {};
        const raw: number | string = (this.state.values || [])[index];
        const type: string = (fields[index] || {}).type || null;
        const value: string = (fields[index] || {})[key];

        if (key === 'name') {
            return type && value === null
                ? 'Bitte Feld "Bezeichnung" ausfüllen'
                : null;
        } else if (key === 'type') {
            const types: string[] = Object.keys(fields).map((key2: string) => fields[key2].type || null);

            switch (true) {
                case value !== 'date' && types.indexOf('date') !== -1 && types.indexOf('time') === -1:
                    return 'Bitte Typ "Zeit" auswählen';
                case value !== 'time' && types.indexOf('date') === -1 && types.indexOf('time') !== -1:
                    return 'Bitte Typ "Datum" auswählen';
                case types.indexOf('date') === -1 && types.indexOf('datetime') === -1 && types.indexOf('time') === -1:
                    return 'Bitte Typ "Datum" oder "Datum/Zeit" auswählen';
                case ['date', 'datetime', 'time'].indexOf(value) === -1 && types.indexOf('value') === -1:
                    return 'Bitte Typ "Wert" auswählen';
                case (['date', 'datetime'].indexOf(type) !== -1 && !this.isDate(index))
                    || (type === 'time' && types.indexOf('date') !== -1 && !this.isTime(index))
                    || (value === 'value' && isNaN(+raw)):
                    return `[${raw}] ist kein gültiger Wert`;
            }
        }

        return null;
    }
}
